
const AboutContact = () => {
    return (
        <div className="w-full h-full flex flex-wrap justify-center items-center mt-[28px]">
            <div className="h-auto xl:h-[132px] text-center w-full w-[284px] md:w-[345px] lg:w-[879px]">
                <span className="text-white text-[10px] lg:text-base font-semibold font-['Open Sans']">
                    «Рускомтехнологии» открыты к взаимовыгодному сотрудничеству с
                    российскими производителями ОС и инфраструктуры.
                    Мы видим огромный потенциал вразвитии технологий импортозамещения в интересах российского ИТ-рынка.
                    <br />
                    <br />
                    Ждем Ваших предложений на почту: 
                </span>
                <a href="mailto:info@ruscomtech.ru" className="text-white text-[10px] lg:text-base font-semibold font-['Open Sans'] ">
                    info@ruscomtech.ru
                </a>
            </div>
        </div>
    );
}

export default AboutContact;